export const maxImageWidth = 1920;

export const maxImageHeight = maxImageWidth * 4;
